import { useRef } from "react"
import { motion } from "framer-motion"
import { FiArrowDownRight } from "react-icons/fi"
import useGlobalContext from "../context/GlobalContext"
import { useFollowPointer } from "../hooks/useFollowPointer"

const Cursor = () => {
  const cursorRef = useRef(null)
  const { cursorType } = useGlobalContext()

  const { x, y } = useFollowPointer(cursorRef)

  return (
    <motion.div
      ref={cursorRef}
      className={`cursor-icon mix-blend-difference ${
        cursorType ? cursorType : ""
      }`}
      animate={{ x, y }}
    >
      {cursorType === "img-hover" ? <FiArrowDownRight /> : null}
    </motion.div>
  )
}

export default Cursor
